// removed by extract-text-webpack-plugin
module.exports = {"page":"_3XJ886QU5J-HL_IM_7B-MS","content":"_2Ll0YHTAIx94dvEthpq2pr","container":"_3Laqwb0a6kD8BqO5RGQDB3","list":"OPPcIGyyKpW1hPO3JIMY","emptyList":"_30Jzn_030n3xvpDKiV0Oc_ OPPcIGyyKpW1hPO3JIMY"};


//////////////////
// WEBPACK FOOTER
// ./src/containers/Desk/style.css
// module id = 532
// module chunks = 0